import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Button } from 'react-bootstrap'

const Form = styled.form`
  
  &::before {
    content: '';
    background: black;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    transition: 0.2s all;
    opacity: ${props => (props.overlay ? '.8' : '0')};
    visibility: ${props => (props.overlay ? 'visible' : 'hidden')};
  }
`

const Submit = styled.span`
  cursor: pointer;
`

const Modal = styled.div`
  background: white;
  padding: 2em;
  border-radius: 2px;
  position: fixed;
  min-width: 75%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  z-index: 99;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  transition: 0.2s all;
  opacity: ${props => (props.visible ? '1' : '0')};
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    min-width: inherit;
    max-width: 400px;
  }
  p {
    line-height: 1.6;
    margin: 0 0 2em 0;
    color: black
  }
`

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

class NewsletterSignup extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      showModal: false,
    }
  }

  handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value,
    })
  }

  handleSubmit = event => {
    if(!this.state.email) return
    fetch('/?no-cache=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'newsletter', ...this.state }),
    })
      .then(this.handleSuccess)
      .catch(error => alert(error))
    event.preventDefault()
  }

  handleSuccess = () => {
    this.setState({
      email: '',
      showModal: true,
    })
  }

  closeModal = () => {
    this.setState({ showModal: false })
  }

  render() {
    return (
      <section className="g-color-white g-bg-primary g-pa-40">
        <div className="container">
          <div className="row">
            <div className="col-md-8 align-self-center">
              <h2 className="h3 g-font-weight-300 g-mb-20 g-mb-0--md">Subscribe to our mailing list</h2>
            </div>
            <div className="col-md-4 align-self-center">
              <Form
                name="newsletter"
                onSubmit={this.handleSubmit}
                data-netlify="true"
                data-netlify-honeypot="bot"
                overlay={this.state.showModal}
                onClick={this.closeModal}
              >
                <div className="input-group g-brd-white--focus">
                  <input className="form-control form-control-lg g-font-size-default g-placeholder-white g-color-white g-bg-transparent g-bg-transparent--focus g-brd-white rounded-0" 
                    name="email" 
                    type="email" 
                    placeholder="Enter your email..." 
                    value={this.state.email}
                    onChange={this.handleInputChange} 
                    required
                    />
                  <div className="input-group-append">
                    <Submit onClick={this.handleSubmit} className="input-group-text g-color-white g-bg-transparent g-brd-white rounded-0"><i className="fa fa-envelope" /></Submit>
                  </div>
                </div>
                <Modal visible={this.state.showModal}>
                  <p>
                    Welcome to Hempgrid! You will receive a confirmation email shortly.
                  </p>
                  <Button onClick={this.closeModal}>Okay</Button>
                </Modal>
              </Form>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

NewsletterSignup.propTypes = {
  data: PropTypes.object,
}

export default NewsletterSignup
